import { FunctionComponent } from 'react'
import { Button, Form } from 'react-bootstrap'

import Icon from 'components/ui/icon'
import SegmentedControl from 'components/ui/segmentedControl'
import { PendingTab } from './transferReport'
import { PENDING_OPTIONS } from './moreMenu'
import transfersCss from '../styles.module.scss'

type ReportToolsProps = {
  search: string
  onSearchChange: (value: string) => void
  onDownload: () => void
  /** Tooltip of the CSV button, e.g. "Baixar repasses pagos". */
  downloadLabel: string
  /** Particular vs. convênios; only for pending titles. */
  pending?: { value: PendingTab; onChange: (value: PendingTab) => void }
}

/**
 * Attendance filter plus, on large screens, the report actions. On phones and tablets the
 * actions live in the three-dots menu (MoreMenu).
 */
const ReportTools: FunctionComponent<ReportToolsProps> = ({
  search,
  onSearchChange,
  onDownload,
  downloadLabel,
  pending,
}) => (
  <>
    <div className={`field-wrap ${transfersCss.reportSearch}`}>
      <Icon name="search" size={14} />
      <Form.Control
        type="number"
        size="sm"
        placeholder="Atendimento"
        aria-label="Filtrar por número de atendimento"
        value={search}
        onChange={(event) => onSearchChange(event.currentTarget.value)}
      />
    </div>

    {pending && (
      <SegmentedControl<PendingTab>
        className="d-none d-lg-inline-flex"
        ariaLabel="Tipo de atendimento"
        value={pending.value}
        onChange={pending.onChange}
        options={PENDING_OPTIONS}
      />
    )}

    <Button
      variant="secondary"
      size="sm"
      className="d-none d-lg-inline-flex"
      title={downloadLabel}
      onClick={onDownload}
    >
      <Icon name="download" />
      Baixar CSV
    </Button>
  </>
)

export default ReportTools
